/**
 * cm-swatch-flag.js
 *
 * Steuert die Sichtbarkeit des NATIVEN Variant-Pickers.
 *
 * Neu (Fix gegen das kurze Aufblitzen beim Reload): Der native Picker ist in
 * assets/cm-custom.css von Anfang an ausgeblendet. Frueher war es umgekehrt —
 * er war sichtbar und wurde erst versteckt, sobald dieses Skript gelaufen war.
 * Dadurch war er auf jeder Produktseite fuer ~1s zu sehen.
 *
 * Dieses Skript setzt jetzt nur noch die AUSNAHME: fehlt die eigene
 * Variantenauswahl, kommt <body class="cm-no-swatches"> dazu und der native
 * Picker wird wieder eingeblendet. Das Produkt bleibt damit in jedem Fall
 * bestellbar.
 *
 * Der native Picker bleibt immer im DOM — seine Radio-Inputs steuern den
 * Variantenwechsel und werden von snippets/cm-variant-swatches.liquid
 * angesteuert.
 */

function cmFlagSwatches() {
  var hasSwatches = document.querySelector('.cm-variant-swatches-block .cm-ws') !== null;
  document.body.classList.toggle('cm-has-swatches', hasSwatches);
  document.body.classList.toggle('cm-no-swatches', !hasSwatches);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', cmFlagSwatches, { once: true });
} else {
  cmFlagSwatches();
}

document.addEventListener('shopify:section:load', cmFlagSwatches);
document.addEventListener('shopify:block:select', cmFlagSwatches);
document.addEventListener('shopify:block:deselect', cmFlagSwatches);
